import { GridCellParams, GridColDef } from "@mui/x-data-grid";
import { useGenGridCol } from "../../../../../utils/HelperComp";
import { usePermission, useTranslation } from "../../../../../hooks";
import {
  translatePrefix,
  translateKeyObj as TK,
  Pkey,
  ITableRes,
} from "../../config";
import {
  useReduxContext,
  setUpdateExchangeRate
} from "../../reduxContext";
import OpIconButton from "../../../../../components/OpIconButton";
import { OpCreateDoc } from "../../../../../assets/icons";


const useTableColumns = () => {

  const { hasPermission } = usePermission();

  const [_, dispatch] = useReduxContext();

  const { t } = useTranslation(translatePrefix);

  const renderOperationButton = (params: GridCellParams<any, any, any>) => {
    const { status } = params.row['rawData'] as ITableRes;

    const onClick = () => {
      dispatch(setUpdateExchangeRate(params.row.rawData))
    };

    return (
      <OpIconButton
        title={t(TK.updateExchangeRate)}
        url={OpCreateDoc}
        size="1.9rem"
        onClick={onClick}
        isDisabled={status === 0}
      />
    );
  };

  const columns: GridColDef[] = [
    useGenGridCol(TK.operation, t(TK.operation), {
      minWidth: 70,
      renderCell: renderOperationButton,
    }),
    useGenGridCol(TK.merchantFrom, t(TK.merchantFrom), { minWidth: 150 }),
    useGenGridCol(TK.chainNameFrom, t(TK.chainNameFrom), { minWidth: 150 }),
    useGenGridCol(TK.currencyFrom, t(TK.currencyFrom), { minWidth: 100 }),
    useGenGridCol(TK.merchantTo, t(TK.merchantTo), { minWidth: 150 }),
    useGenGridCol(TK.chainNameTo, t(TK.chainNameTo), { minWidth: 150 }),
    useGenGridCol(TK.currencyTo, t(TK.currencyTo), { minWidth: 150 }),
    useGenGridCol(TK.merchantLp, t(TK.merchantLp), { minWidth: 150, }),
    useGenGridCol(TK.liquidityProvider, t(TK.liquidityProvider), { minWidth: 150, }),
    useGenGridCol(TK.exchangeRate, t(TK.exchangeRate), { minWidth: 150, }),
    useGenGridCol(TK.creationTime, t(TK.creationTime), { minWidth: 150, }),
    useGenGridCol(TK.lastModifiedTime, t(TK.lastModifiedTime), { minWidth: 150, }),
    useGenGridCol(TK.lastModifiedTimeExchangeRate, t(TK.lastModifiedTimeExchangeRate), { minWidth: 200, }),
  ].filter(({ field }) => {
    if (field === TK.operation) {
      return hasPermission(Pkey.TabLiquidityProvider.EditExchangeRate);
    }
    return true;
  });

  return { columns };

};

export default useTableColumns;